import withLandingPage from './withLandingPage';

export default withLandingPage;
